import type { CollectorSelfProfileOptions } from './collectorSelfProfileOptions';
import { client } from '../client';
import { Address, UserProfile, UserRoleName } from './types/UserProfile';

export interface UpdateMe {
  address?: Address;
  phone_number?: string | null;
  email_opt_in?: boolean;
  sms_opt_in?: boolean;
  other_insurance_name?: string;
}

/** Collector: `collectorEditingSelf` → PATCH /collector/me; else PATCH /collector/users/{user_id} (managed only). */
export const updateMe = async (
  payload: UpdateMe,
  user_id: number,
  userRole?: string,
  options?: CollectorSelfProfileOptions,
): Promise<UserProfile> => {
  const prefix =
    userRole === UserRoleName.CareAdvisor ? '/care_advisor' : userRole === UserRoleName.Collector ? '/collector' : '';
  const useCollectorMe =
    userRole === UserRoleName.Collector && options?.collectorEditingSelf === true;
  const purifiedPayload: any = {
    address: payload.address,
    email_opt_in: payload.email_opt_in,
    sms_opt_in: payload.sms_opt_in,
    other_insurance_name: payload.other_insurance_name,
  };

  // Distinguish "phone not part of this update" (undefined → leave the stored
  // value untouched) from "phone explicitly cleared" (empty/whitespace → send
  // null so the API deletes it). Sending null rather than "" avoids tripping
  // the server-side phone_number regex.
  if (payload.phone_number !== undefined) {
    purifiedPayload.phone_number = payload.phone_number?.trim() ? payload.phone_number : null;
  }

  const url = useCollectorMe ? '/collector/me' : `${prefix}/users/${user_id}`;
  const { data } = await client.patch<UserProfile>(url, purifiedPayload);

  return data;
};
